import React from 'react';
import { Check, Minus, ChatCircleDots } from '@phosphor-icons/react';
import { Popover, PopoverContent, PopoverTrigger } from '../../ui/popover';

export const CELL_STYLE = {
  not_started: 'bg-red-500 border-red-600',
  in_progress: 'bg-yellow-400 border-yellow-500',
  completed: 'bg-green-500 border-green-600',
  monitored: 'bg-green-500 border-green-600',
  na: 'bg-stone-100 border-stone-200',
};

const Q_LABEL = {
  es: { not_started: 'sin empezar', in_progress: 'guardado', completed: 'terminado' },
  en: { not_started: 'not started', in_progress: 'saved', completed: 'finished' },
};

const itemLine = (it, lang) => {
  const st = (Q_LABEL[lang] || Q_LABEL.es)[it.status];
  const rev = it.status === 'completed' ? `, ${it.checked}/${it.total} ${lang === 'es' ? 'revisadas' : 'reviewed'}` : '';
  const mon = it.monitored ? (lang === 'es' ? ' · monitorizado' : ' · monitored') : '';
  const q = it.queries ? ` · ${it.queries} quer${it.queries === 1 ? 'y' : 'ies'}` : '';
  return `${it.name}: ${st}${rev}${mon}${q}`;
};

export const CellSwatch = ({ state, queries, size = 'h-9 w-9' }) => (
  <span className={`relative inline-flex ${size} items-center justify-center rounded-sm border ${CELL_STYLE[state]}`}>
    {state === 'monitored' && <Check size={16} weight="bold" className="text-white" />}
    {state === 'na' && <Minus size={12} className="text-stone-400" />}
    {queries > 0 && (
      <span className="absolute -top-1.5 -right-1.5 min-w-[16px] h-4 px-1 rounded-full bg-red-600 ring-2 ring-white text-[9px] font-bold text-white leading-4 text-center">
        {queries}
      </span>
    )}
  </span>
);

const StatusDot = ({ it }) => (
  <span className={`inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-full ${CELL_STYLE[it.monitored ? 'monitored' : it.status]}`}>
    {it.monitored && <Check size={10} weight="bold" className="text-white" />}
  </span>
);

// Casilla de la matriz: color resumen, contador de queries y desplegable de cuestionarios.
export const MatrixCell = ({ cell, row, visit, dimmed, onOpen, onHover, lang }) => {
  const testId = `mx-cell-${row.code || row.volunteer_id}-${visit.code}`;
  if (cell.state === 'na') {
    return (
      <div data-testid={testId} title={lang === 'es' ? 'No aplica' : 'Not applicable'} onMouseEnter={onHover}
        className={`flex justify-center ${dimmed ? 'opacity-25' : ''}`}>
        <CellSwatch state="na" queries={0} />
      </div>
    );
  }
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testId} data-state-summary={cell.state} onMouseEnter={onHover}
          title={(cell.items || []).map(it => itemLine(it, lang)).join('\n')}
          className={`flex w-full justify-center transition-opacity duration-150 hover:scale-105 ${dimmed ? 'opacity-25' : ''}`}>
          <CellSwatch state={cell.state} queries={cell.queries} />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-80 p-2" data-testid={`${testId}-menu`}>
        <p className="px-2 pb-1.5 text-[11px] font-semibold uppercase tracking-wider text-stone-500">
          {row.code} · {visit.code}
        </p>
        {(cell.items || []).map(it => (
          <button key={it.questionnaire_id} type="button" data-testid={`${testId}-q-${it.questionnaire_id}`}
            onClick={() => onOpen(row, visit, it)}
            className="flex w-full items-center gap-2 rounded-sm px-2 py-1.5 text-left text-sm hover:bg-stone-100">
            <StatusDot it={it} />
            <span className="min-w-0 flex-1 truncate text-stone-800">{it.name}</span>
            {it.status === 'completed' && <span className="text-[10px] text-stone-400">{it.checked}/{it.total}</span>}
            {it.queries > 0 && (
              <span className="inline-flex items-center gap-0.5 text-[10px] font-semibold text-red-600">
                <ChatCircleDots size={11} weight="fill" />{it.queries}
              </span>
            )}
          </button>
        ))}
      </PopoverContent>
    </Popover>
  );
};
